<template>
  <div>
    <div class="panel-header d-none d-md-flex">
      <div class="col-12 col-sm-2 panel-title">
        Nombre
        <span class="small-block">Categoría</span>
      </div>
      <div class="col-12 col-sm-3 panel-title">
        Descripción
        <span class="small-block">Empaque - Código</span>
      </div>
      <div class="col-12 col-sm-2 text-right panel-title">
        Cantidad
        <span class="small-block">Unidad</span>
      </div>
      <div class="col-12 col-sm-2 panel-title">
        Observación
      </div>
      <div class="panel-icon">
      </div>
    </div>
    <div class="custom-expansion-panels">
      <div v-for="(not, index) in notas" :key="index" :class="['panel-item', { 'panel-open': isOpen(index) }]">
        <!-- Cabecera del Panel -->
        <button class="panel-sub-header d-sm-flex" @click="togglePanel(index)">
          <div class="col-12 col-sm-2 panel-title-item">
            <p class="d-block d-sm-none panel-title">
              Nombre
            </p>
            {{ not.nom_pro }}
            <p class="d-block d-sm-none panel-title">
              Categoría
            </p>
            <span class="small-block">{{ not.nom_cat }}</span>
          </div>
          <div class="col-12 col-sm-3 panel-title-item">
            <p class="d-block d-sm-none panel-title">
              descripción
            </p>
            {{ not.des_pre }}
            <p class="d-block d-sm-none panel-title">
              empaque - Código
            </p>
            <span class="small-block">{{ not.tip_pre }} - {{ not.cod_pre }}</span>
          </div>
          <div class="col-12 col-sm-2 text-sm-right panel-title-item">
            <p class="d-block d-sm-none panel-title">
              Cantidad
            </p>
            {{ not.can_nd }}
            <p class="d-block d-sm-none panel-title">
              Unidad
            </p>
            <span class="small-block">{{ not.can_ind_nd }}</span>
          </div>
          <div class="col-12 col-sm-2 panel-title-item">
            <p class="d-block d-sm-none panel-title">
              Observación
            </p>
            {{ not.obs_nd }}
          </div>
          <span class="panel-icon" :class="{ 'rotate-icon': isOpen(index) }">▼</span>
        </button>
        <!-- Contenido Animado -->
        <transition name="expand" @before-enter="beforeEnter" @enter="enter" @after-enter="afterEnter"
          @before-leave="beforeLeave" @leave="leave" @after-leave="afterLeave">
          <div v-show="isOpen(index)" class="panel-content-wrapper">
            <div class="panel-content">
              <h5>Detalles</h5>
              <template v-if="motivosPorNota(not.id_nd).length">
                <div v-for="(mot, indexM) in motivosPorNota(not.id_nd)" :key="mot.id_not_did + indexM"
                  class="panel-items">
                  <div class="card my-1 p-2">
                    <div class="panel-content-item d-sm-flex flex-wrap">
                      <div class="col-12 col-sm text-caption">
                        <p class="titulo">
                          Lote
                        </p>
                        <p class="description">
                          {{ mot.lote_did || 'Sin especificar' }}
                        </p>
                      </div>
                      <div class="col-12 col-sm text-caption">
                        <p class="titulo">
                          Cantidad
                        </p>
                        <p class="description">
                          {{ mot.can_did || 0 }}
                        </p>
                      </div>
                      <div class="col-12 col-sm text-caption">
                        <p class="titulo">
                          Unidad
                        </p>
                        <p class="description">
                          {{ mot.uni_did || 0 }}
                        </p>
                      </div>
                      <div class="col-12 col-sm text-caption">
                        <p class="titulo">
                          Fecha de vencimiento
                        </p>
                        <p class="description">
                          {{ mot.fec_ven_did || 'Sin especificar' }}
                        </p>
                      </div>
                      <div class="col-12 col-sm text-caption">
                        <p class="titulo">
                          Fecha de elaboración
                        </p>
                        <p class="description">
                          {{ mot.fec_ela_did || 'Sin especificar' }}
                        </p>
                      </div>
                      <div class="col-12 col-sm text-caption">
                        <p class="titulo">
                          Motivo
                        </p>
                        <p class="description">
                          {{ mot.motivo_did || 'Sin especificar' }}
                        </p>
                      </div>
                      <div class="col-12 col-sm text-caption">
                        <p class="titulo">
                          Observación
                        </p>
                        <p class="description">
                          {{ mot.obs_did || 'Sin especificar' }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <p class="text-caption text-center">Sin detalles de devolución</p>
              </template>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PanelExpansivo',
  props: {
    // Array de objetos: [{ title: 'Título', content: 'Contenido' }]
    notas: {
      type: Array,
      required: true,
    },
    motivos: {
      type: Array,
      required: false,
    },
    // Si es true, permite abrir varios. Si es false, actúa como acordeón estricto
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Guardamos los índices de los panels abiertos
      openedPanels: [],
    };
  },
  methods: {
    motivosPorNota(idNd) {
      return this.motivos.filter((m) => m.id_not_did === idNd);
    },
    isOpen(index) {
      return this.openedPanels.includes(index);
    },
    togglePanel(index) {
      if (this.multiple) {
        // Modo múltiple: quita o pone el índice en el array
        const idx = this.openedPanels.indexOf(index);
        if (idx > -1) {
          this.openedPanels.splice(idx, 1);
        } else {
          this.openedPanels.push(index);
        }
      } else {
        // Modo acordeón: si ya está abierto lo cierra, si no, abre solo ese
        if (this.isOpen(index)) {
          this.openedPanels = [];
        } else {
          this.openedPanels = [index];
        }
      }
    },
    // --- JavaScript Hooks para animar la altura (height: auto) de forma fluida ---
    beforeEnter(el) {
      el.style.height = '0';
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter(el) {
      el.style.height = 'auto';
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px';
      // Forzar reflow
      el.offsetHeight;
    },
    leave(el) {
      el.style.height = '0';
    },
    afterLeave(el) {
      el.style.height = 'auto';
    },
  },
};
</script>

<style scoped>
.custom-expansion-panels {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  font-family: sans-serif;
}

.panel-item {
  border-bottom: 1px solid #e0e0e0;
}

.panel-item:last-child {
  border-bottom: none;
}

.panel-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #fafafa;
}

.panel-sub-header {
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #ffffff;
  border: none;
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  font-weight: 500;
}

.panel-items {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.panel-content-item {
  width: 100%;
  justify-content: space-between !important;
}

.panel-title {
  font-size: .7rem;
  text-transform: uppercase;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.729);
}

.panel-title span {
  color: rgba(0, 0, 0, 0.50);
  font-size: .55rem;
}

.panel-title-item {
  font-size: .8rem;
  font-weight: 100;
  color: rgba(0, 0, 0, 0.729);
}

.panel-title-item span {
  color: rgba(0, 0, 0, 0.50);
  font-size: .7rem;
  font-weight: lighter;
}

.panel-icon {
  font-size: 12px;
  transition: transform 0.3s ease;
  color: #757575;
  width: 20px;
}

.rotate-icon {
  transform: rotate(180deg);
}

/* Contenedor de la transición */
.panel-content-wrapper {
  overflow: hidden;
  transition: height 0.3s ease-in-out;
}

.panel-content {
  padding: 1rem;
  background-color: #fafafa;
  color: #424242;
  line-height: 1.5;
}

.titulo {
  font-size: .8rem;
  font-weight: bold;
}

.description {
  font-size: .8rem;
  font-weight: lighter;
}
</style>
